/*
 * SMParts — interne Eigenschaften im Upcart-Warenkorb ausblenden
 *
 * Apps haengen Warenkorb-Positionen versteckte Eigenschaften an, z. B.
 * Sternify beim Stunt Set: "_sternify_product_set: 3f2b0c42-…". Nach
 * Shopify-Konvention sind Eigenschaften mit Unterstrich vorne intern
 * und werden nicht angezeigt — Upcart zeigt sie trotzdem.
 *
 * Upcart zeichnet den Warenkorb in einem Shadow DOM; Theme-CSS kommt
 * dort nicht hin. Dieses Skript sucht die Upcart-Wurzel, beobachtet sie
 * und blendet jede Eigenschaft aus, deren Text mit "_" beginnt.
 * Sichtbare Eigenschaften (z. B. "Modell: KTM 125 EXC") bleiben.
 *
 * Ausserdem: Sterne-Bewertungen bei den Upsells ("Das wirst Du lieben!")
 * ausblenden – dort standen 1-Stern-Werte mit "(1 reviews)".
 *
 * Und: Gratis-Sticker mit Farbwahl direkt im Warenkorb (Wunsch Andreas,
 * 27.10.2026). Die Upcart-Belohnung "Kostenlose Sticker" ist nur eine
 * Beschriftung ohne Produkt, der Sticker kam bisher nur ueber seine
 * Produktseite in den Korb. Unter den Positionen stehen jetzt die acht
 * Farben; Antippen legt den Sticker (1 Stueck, 0 €) dazu oder tauscht
 * die Farbe. Leerer Korb oder nur der Sticker drin: kein Block.
 * Hoechstens 1 Sticker: "+" an der Sticker-Zeile gesperrt, mehr Stueck
 * (z. B. ueber die Produktseite) werden auf 1 zurueckgesetzt.
 */
(function () {
  'use strict';

  var beobachtet = new WeakSet();

  var STICKER_ID = 9840412426506;
  var STICKER_HANDLE = '🎁-gratis-smparts-stickers';
  var FARBEN = {
    'Weiß': '#ffffff',
    'Lila': '#8e44ad',
    'Rosa': '#ff7eb9',
    'Rot': '#e30613',
    'Orange': '#ff7a00',
    'Grün': '#2fb344',
    'Blau': '#1e6fff',
    'Chrome': 'linear-gradient(135deg,#f4f4f4 0%,#9a9a9a 45%,#ffffff 55%,#7d7d7d 100%)'
  };
  var STICKER_CSS =
    '.smp-st{margin:12px 16px 4px;padding:12px 14px;border:1px solid #e5e5e5;border-radius:10px;background:#fafafa;font-family:inherit}' +
    '.smp-st__kopf{font-weight:700;font-size:14px;line-height:1.3;color:#000}' +
    '.smp-st__sub{font-size:12px;line-height:1.35;color:#555;margin-top:2px}' +
    '.smp-st__reihe{display:flex;flex-wrap:wrap;gap:8px 6px;margin-top:10px}' +
    '.smp-st__f{all:unset;box-sizing:border-box;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:3px;width:40px;-webkit-tap-highlight-color:transparent}' +
    '.smp-st__p{width:30px;height:30px;border-radius:50%;border:1px solid rgba(0,0,0,.25);box-shadow:inset 0 0 0 2px #fff}' +
    '.smp-st__f[aria-pressed="true"] .smp-st__p{outline:2px solid #000;outline-offset:2px}' +
    '.smp-st__n{font-size:10px;line-height:1.1;color:#333}' +
    '.smp-st__f:focus-visible .smp-st__p{outline:2px solid #1e6fff;outline-offset:2px}' +
    '.smp-st.is-laedt{opacity:.55;pointer-events:none}';

  var sticker = null; // Varianten aus /products/<handle>.js
  var korb = null; // letzter Stand von /cart.js
  var korbSig = '';
  var laedt = false;

  function stickerHolen() {
    if (sticker) return Promise.resolve(sticker);
    return fetch('/products/' + encodeURIComponent(STICKER_HANDLE) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.available) return null;
        sticker = p.variants.filter(function (v) { return v.available; });
        return sticker;
      })
      .catch(function () { return null; });
  }

  function korbHolen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { korb = c; return c; });
  }

  function stickerZeilen(c) {
    return (c && c.items ? c.items : []).filter(function (i) { return i.product_id === STICKER_ID; });
  }

  /* Hoechstens ein Gratis-Sticker pro Bestellung. Kommen ueber die
     Produktseite oder mehrere Farben mehr in den Korb, bleibt nur die
     erste Zeile mit Menge 1. Liefert true, wenn korrigiert wird. */
  function mengeBegrenzen(wurzel) {
    var zeilen = stickerZeilen(korb);
    var summe = zeilen.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (summe <= 1 || laedt) return false;
    var updates = {};
    zeilen.forEach(function (i, n) { updates[i.key] = n === 0 ? 1 : 0; });
    laedt = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { korb = c; })
      .catch(function () {})
      .then(function () {
        laedt = false;
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        stickerZeichnen(wurzel);
      });
    return true;
  }

  /* "+" und Mengenfeld an der Sticker-Zeile sperren; Upcart zeichnet
     neu, deshalb bei jedem Durchlauf. */
  function plusSperren(wurzel) {
    var zeilen = wurzel.querySelectorAll('.upcart-public-cart-item');
    for (var i = 0; i < zeilen.length; i++) {
      if (zeilen[i].textContent.indexOf('Gratis SMParts-Sticker') === -1) continue;
      var plus = zeilen[i].querySelector('[aria-label="Increase quantity"]');
      if (plus && !plus.disabled) {
        plus.disabled = true;
        plus.style.opacity = '.3';
        plus.style.pointerEvents = 'none';
      }
      var feld = zeilen[i].querySelector('input');
      if (feld && !feld.readOnly) feld.readOnly = true;
    }
  }

  function farbeWaehlen(wurzel, variante) {
    if (laedt || !korb) return;
    // Ueber Zeilen-Keys statt Varianten-IDs: dieselbe Farbe kann in zwei
    // Zeilen stehen (z. B. mit und ohne "Motorrad"-Eigenschaft).
    var updates = {};
    var behalten = false;
    stickerZeilen(korb).forEach(function (i) {
      var nehmen = !behalten && i.variant_id === variante.id;
      if (nehmen) behalten = true;
      updates[i.key] = nehmen ? 1 : 0;
    });
    if (!behalten) updates[variante.id] = 1;
    laedt = true;
    stickerZeichnen(wurzel);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { korb = c; })
      .catch(function () {})
      .then(function () {
        laedt = false;
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        stickerZeichnen(wurzel);
      });
  }

  function stickerZeichnen(wurzel) {
    var anker = wurzel.querySelector('.upcart-public-notes') || wurzel.querySelector('.upcart-public-upsell');
    var block = wurzel.querySelector('.smp-st');
    var andere = (korb && korb.items ? korb.items : []).filter(function (i) {
      return i.product_id !== STICKER_ID && i.final_price > 0 && !/shipping protection/i.test(i.product_title);
    });
    if (!sticker || !sticker.length || !korb || !andere.length || !anker) {
      if (block) block.remove();
      return;
    }
    if (!block) {
      block = document.createElement('div');
      block.className = 'smp-st';
    }
    if (block.nextSibling !== anker) anker.parentNode.insertBefore(block, anker);

    var drin = stickerZeilen(korb);
    var aktiv = drin.length === 1 ? drin[0].variant_id : null;
    var aktivName = '';
    var html = '';
    sticker.forEach(function (v) {
      var name = v.option1;
      if (v.id === aktiv) aktivName = name;
      html +=
        '<button type="button" class="smp-st__f" data-id="' + v.id + '" aria-pressed="' + (v.id === aktiv) + '" aria-label="Sticker in ' + name + '">' +
        '<span class="smp-st__p" style="background:' + (FARBEN[name] || '#ccc') + '"></span>' +
        '<span class="smp-st__n">' + name + '</span></button>';
    });
    var kopf = aktivName ? '🎁 Dein Gratis-Sticker: ' + aktivName : '🎁 Gratis-Sticker dazu?';
    var sub = aktivName ? 'Andere Farbe? Einfach antippen.' : 'Farbe antippen – kommt kostenlos mit deiner Bestellung.';
    var sig = kopf + '|' + aktiv + '|' + laedt;
    if (block.getAttribute('data-sig') !== sig) {
      block.setAttribute('data-sig', sig);
      block.innerHTML =
        '<div class="smp-st__kopf">' + kopf + '</div><div class="smp-st__sub">' + sub + '</div>' +
        '<div class="smp-st__reihe">' + html + '</div>';
      block.classList.toggle('is-laedt', laedt);
      var knoepfe = block.querySelectorAll('.smp-st__f');
      for (var i = 0; i < knoepfe.length; i++) {
        knoepfe[i].addEventListener('click', function (ev) {
          var id = Number(ev.currentTarget.getAttribute('data-id'));
          if (id === aktiv) return;
          var v = sticker.filter(function (x) { return x.id === id; })[0];
          if (v) farbeWaehlen(wurzel, v);
        });
      }
    }
  }

  /* Upcart zeichnet bei jeder Korb-Aenderung neu; /cart.js nur holen,
     wenn sich die Positionen sichtbar geaendert haben. */
  function stickerPruefen(wurzel) {
    var zeilen = wurzel.querySelectorAll('.upcart-public-cart-item');
    var sig = zeilen.length + ':';
    for (var i = 0; i < zeilen.length; i++) {
      var menge = zeilen[i].querySelector('input');
      sig += zeilen[i].textContent.length + '/' + (menge ? menge.value : '') + ';';
    }
    if (sig !== korbSig && !laedt) {
      korbSig = sig;
      Promise.all([stickerHolen(), korbHolen()]).then(function () {
        if (!mengeBegrenzen(wurzel)) stickerZeichnen(wurzel);
      });
    } else {
      stickerZeichnen(wurzel);
    }
  }

  function aufraeumen(wurzel) {
    // Stil gegen die Upsell-Sterne; neu setzen, falls Upcart neu zeichnet
    if (!wurzel.querySelector('style[data-smp-upcart]')) {
      var stil = document.createElement('style');
      stil.setAttribute('data-smp-upcart', '');
      stil.textContent =
        '[class*="upsell-tile__rating-row"],[class*="upsell-tile__stars"],[class*="upsell-tile__reviews"]{display:none!important}' +
        STICKER_CSS;
      wurzel.appendChild(stil);
    }
    var eintraege = wurzel.querySelectorAll('.upcart-public-product-properties__item');
    for (var i = 0; i < eintraege.length; i++) {
      var e = eintraege[i];
      if (e.textContent.trim().charAt(0) === '_') e.style.display = 'none';
    }
    plusSperren(wurzel);
    stickerPruefen(wurzel);
  }

  function anbinden(wurzel) {
    if (beobachtet.has(wurzel)) return;
    beobachtet.add(wurzel);
    aufraeumen(wurzel);
    new MutationObserver(function () {
      aufraeumen(wurzel);
    }).observe(wurzel, { childList: true, subtree: true });
  }

  /* Upcart haengt sich als App-Block in den Body; die Wurzel entsteht
     erst, wenn das Skript der App geladen ist. */
  function suchen() {
    var bloecke = document.querySelectorAll('.shopify-app-block, [id*="upcart"]');
    for (var i = 0; i < bloecke.length; i++) {
      var kandidaten = bloecke[i].querySelectorAll('*');
      for (var j = 0; j < kandidaten.length; j++) {
        var w = kandidaten[j].shadowRoot;
        if (w && !beobachtet.has(w) && /upcart/i.test(w.innerHTML.slice(0, 5000))) anbinden(w);
      }
    }
  }

  var versuche = 0;
  var takt = setInterval(function () {
    suchen();
    if (++versuche > 30) clearInterval(takt);
  }, 1000);

  /* Spaeter erzeugte Wurzeln (Upcart baut beim Oeffnen manchmal neu). */
  document.addEventListener('click', function () {
    setTimeout(suchen, 400);
  }, true);
})();
